import { useTranslation } from 'react-i18next'
import { MapPin, Clock, Phone, Mail } from 'lucide-react'
import { PageShell } from '../../components/layout/PageShell'
import { Button } from '../../components/ui/Button'
import { MapView } from '../../components/ui/MapView'

const MARKER = { lat: 45.4378, lon: 12.3186 }
const OSM_FULL = `https://www.openstreetmap.org/?mlat=${MARKER.lat}&mlon=${MARKER.lon}#map=17/${MARKER.lat}/${MARKER.lon}`

export function ContactsPage() {
  const { t } = useTranslation()
  return (
    <PageShell>
      <div className="mb-6">
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-ink-900 sm:text-3xl">{t('contacts.title')}</h1>
        <p className="mt-1.5 text-sm text-ink-500">{t('contacts.subtitle')}</p>
      </div>

      <div className="overflow-hidden rounded-2xl bg-white shadow-card ring-1 ring-ink-100">
        <MapView lat={MARKER.lat} lon={MARKER.lon} className="aspect-[16/11] w-full sm:aspect-[2/1]" />
        <div className="space-y-4 p-6">
          <Row icon={<MapPin className="h-4 w-4 text-brand-600" />} label={t('contacts.address')} value={t('home.address')} />
          <Row icon={<Clock className="h-4 w-4 text-brand-600" />} label={t('contacts.hours')} value={t('home.hours')} />
          <Row icon={<Phone className="h-4 w-4 text-brand-600" />} label={t('contacts.phone')} value={t('contacts.phoneTodo')} />
          <Row
            icon={<Mail className="h-4 w-4 text-brand-600" />}
            label={t('contacts.email')}
            value={<a href={`mailto:${t('contacts.emailVal')}`} className="text-brand-600 hover:text-brand-800">{t('contacts.emailVal')}</a>}
          />
          <a href={OSM_FULL} target="_blank" rel="noreferrer" className="inline-block pt-1">
            <Button variant="outline" leftIcon={<MapPin className="h-4 w-4" />}>{t('home.directions')}</Button>
          </a>
          <p className="text-xs text-ink-400">{t('contacts.note')}</p>
        </div>
      </div>
    </PageShell>
  )
}

function Row({ icon, label, value }: { icon: React.ReactNode; label: string; value: React.ReactNode }) {
  return (
    <div className="flex items-start gap-3">
      <span className="mt-0.5 flex-none">{icon}</span>
      <div className="min-w-0">
        <p className="text-xs font-medium uppercase tracking-wide text-ink-400">{label}</p>
        <p className="text-sm font-semibold text-ink-900">{value}</p>
      </div>
    </div>
  )
}
